import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import CommunityThemeFields from "./CommunityThemeFields";

/**
 * Shared community profile editor (org settings expand-edit + community page Edit).
 * value keys: display_name?, description, join_policy, posting_policy,
 * brand_primary, brand_secondary, brand_accent, guidelines
 */
export default function CommunitySpaceEditForm({
  value,
  onChange,
  disabled = false,
  idPrefix = "community-edit",
  showDisplayName = true,
}) {
  const form = value || {};
  const setField = (key, next) => onChange?.({ ...form, [key]: next });

  return (
    <div className="space-y-3">
      {showDisplayName ? (
        <div className="space-y-2">
          <Label htmlFor={`${idPrefix}-name`}>Name</Label>
          <Input
            id={`${idPrefix}-name`}
            value={form.display_name || ""}
            onChange={(e) => setField("display_name", e.target.value)}
            disabled={disabled}
            placeholder="Community name"
          />
        </div>
      ) : null}
      <div className="space-y-2">
        <Label htmlFor={`${idPrefix}-desc`}>Description</Label>
        <textarea
          id={`${idPrefix}-desc`}
          rows={2}
          value={form.description || ""}
          onChange={(e) => setField("description", e.target.value)}
          className="w-full resize-y rounded-md border border-input bg-background px-3 py-2 text-sm"
          disabled={disabled}
        />
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        <div className="space-y-1.5">
          <Label htmlFor={`${idPrefix}-join`}>Join policy</Label>
          <select
            id={`${idPrefix}-join`}
            value={form.join_policy || "open"}
            onChange={(e) => setField("join_policy", e.target.value)}
            className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm"
            disabled={disabled}
          >
            <option value="open">Open</option>
            <option value="request">Request</option>
            <option value="invite_only">Invite only</option>
          </select>
        </div>
        <div className="space-y-1.5">
          <Label htmlFor={`${idPrefix}-posting`}>Posting policy</Label>
          <select
            id={`${idPrefix}-posting`}
            value={form.posting_policy || "official_only"}
            onChange={(e) => setField("posting_policy", e.target.value)}
            className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm"
            disabled={disabled}
          >
            <option value="official_only">Official only</option>
            <option value="community_posts">Community posts</option>
          </select>
        </div>
      </div>
      <CommunityThemeFields
        idPrefix={idPrefix}
        disabled={disabled}
        value={form}
        onChange={(next) => onChange?.(next)}
      />
    </div>
  );
}
